import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Paper, Typography } from '@material-ui/core';
import { I18n } from 'react-redux-i18n';

import MsTable from '../../table/MsTable';

import { getAllInvoices } from '../../../redux/actions/tracker/invoiceActions';
import PageBase from '../../../app/PageBase';

class CompanyTable extends Component {

    static propTypes = {
      data: PropTypes.array,
    };

    static defaultProps = {
      data: [],
    };

    constructor(props) {

      super(props);
      this.isSelected = this.isSelected.bind(this);
      this.state = {
        response: [],
        selected: [],
      };

    }

    componentWillMount() {

      const payLoadParams = {
        holdingId: this.props.user.context.idHolding,
        companyid: this.props.user.context.idCompany,
      };

      getAllInvoices(payLoadParams).then(response => this.setState({ response }));


    }


    handleRowSelection = (selectedRows) => {

      const selectedInvoices = selectedRows.map(rowIndex => this.props.data[rowIndex]);

      this.setState({
        selected: selectedInvoices,
      });

    };

    render() {

      const { response } = this.state;

      return (
        <div>
          <PageBase
            title={I18n.t('menu.invoiceList')}
            navigation={`Notas - ${I18n.t('menu.invoiceList')}`}
          >
            <MsTable
              selectable={false}
              data={response}
              entryKey="invoiceId"
              paginate
              onPaginate={this.onPaginate}
              handleEditClick={this.handleEditClick}
              handleDeleteClick={this.handleDeleteClick}
              tableDef={[
                { name: 'codeBar', label: 'Codigo de Barras' },
                { name: 'invoiceNumber', label: 'Numero da nota' },
                { name: 'workflowName', label: 'Workflow' },
                { name: 'userName', label: 'Nome do usuario' },
                { name: 'login', label: 'Login do usuario' },
                { name: 'companyName', label: 'Nome da Empresa' },
              ]}
            />
          </PageBase>
        </div >
      );

    }

}

export default withRouter(CompanyTable);



// WEBPACK FOOTER //
// ./src/components/tracker/Invoice/InvoiceList.js